module.exports = __webpack_public_path__ + "static/presidents-message-menu-thumbnails-400x400-0f8379a7e5afeeb82210454ccea23915.jpg";